import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'
import CO2Service from '~/api/services/co2'
import ResultsCo2 from './ResultsCo2'

interface Props {
  id: Nullable<string>
  handleClose: () => void
  uniqueId: Nullable<string>
  farmerId: string
}

const PreviewModal: React.FC<Props> = (props) => {
  const { id, handleClose, uniqueId, farmerId } = props
  const { t } = useTranslation()

  const [submitPreviewData, setSubmitPreviewData] = useState(null)
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if (id) {
      fetchPreviewData()
    }
  }, [id])

  async function fetchPreviewData() {
    setIsBusy(true)
    try {
      const response = await CO2Service.getCO2FarmerResults(id, farmerId)
      const grouped = {
        cowResults: {
          inventoryAddition: response.data.inventoryAddition,
          calfRearing: response.data.calfRearing,
          digestion: response.data.digestion,
          feedProductionAndLosses: response.data.feedProductionAndLosses,
          manureAndBedding: response.data.manureAndBedding,
          waterAndEnergy: response.data.waterAndEnergy,
          dieselProductionAndCombustion: response.data.dieselProductionAndCombustion,
          machineManufacturing: response.data.machineManufacturing,
          total: response.data.total,
          ghgEmissionMilkIdf: response.data.ghgEmissionMilkIdf,
          ghgEmissionSlaughterCowsIdf: response.data.ghgEmissionSlaughterCowsIdf,
          ghgEmissionCalvesIdf: response.data.ghgEmissionCalvesIdf
        },
        heiferResults: {
          id: response.data.id,
          farmerId: response.data.farmerId,
          youngCattleFemaleCalf: response.data.youngCattleFemaleCalf,
          youngCattleDigestion: response.data.youngCattleDigestion,
          youngCattleFeedProductionAndLosses: response.data.youngCattleFeedProductionAndLosses,
          youngCattleGhgEmissionHeifersIdf: response.data.youngCattleGhgEmissionHeifersIdf,
          youngCattleManureAndBedding: response.data.youngCattleManureAndBedding,
          youngCattleWaterAndEnergy: response.data.youngCattleWaterAndEnergy,
          youngCattleDieselProductionAndCombustion: response.data.youngCattleDieselProductionAndCombustion,
          youngCattleMachineManufacturing: response.data.youngCattleMachineManufacturing,
          youngCattleTotal: response.data.youngCattleTotal,
          completed: response.data.completed,
          createdAt: response.data.createdAt,
          updatedAt: response.data.updatedAt,
          soldMilk: response.data.soldMilk,
          soldMilkFpcm: response.data.soldMilkFpcm,
          soldMilkEconomicAllocationFpcm: response.data.soldMilkEconomicAllocationFpcm,
          soldMilkEconomicAllocationFpcmIdf: response.data.soldMilkEconomicAllocationFpcmIdf,
          youngCattleGhgEmissionIdfPerHeifer: response.data.youngCattleGhgEmissionIdfPerHeifer,
          youngCattleGhgEmissionFromInputUseAndAnimalPurchase: response.data.youngCattleGhgEmissionFromInputUseAndAnimalPurchase,
          youngCattleGhgEmissionFromAnimalHusbandryPractices: response.data.youngCattleGhgEmissionFromAnimalHusbandryPractices,
          youngCattleGhgEmissionPerKgOfLivestockPerHeifer: response.data.youngCattleGhgEmissionPerKgOfLivestockPerHeifer,
          youngCattleGhgEmissionWithEconomicAllocationPerHeifer: response.data.youngCattleGhgEmissionWithEconomicAllocationPerHeifer
        }
      }
      setSubmitPreviewData(grouped)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(id)}
    isLoading={isBusy}
    style={{ width: '80%' }}
    textHeader={t('GHG emission results for data collection {{id}}', { id: uniqueId })}
    textContent={<>
      {submitPreviewData && <ResultsCo2 results={submitPreviewData} removeMargin />}
    </>}
    handleClose={() => handleClose()}
    textClose={t('Close')}
  />

}
export default PreviewModal